import React, { useMemo } from 'react'
import { Step } from '../types'

export interface Props {
  steps?: Step[]
  width?: number
  height?: number
  className?: string
}

const getAttrs = (width: number, height: number, len: number) => {
  const horizontal = width > 703 // Brittle, but this is the container size when tailwind breakpoint hits

  const line = {
    x1: horizontal ? 2 : width / 2,
    y1: horizontal ? height / 2 : 2,
    x2: horizontal ? width - 8 : width / 2,
    y2: horizontal ? height / 2 : height - 8,
  }

  const getCircle = (idx: number) => ({
    cx: horizontal ? (idx * width) / len + 14 : width / 2,
    cy: horizontal ? height / 2 : (idx * height) / len + 14,
  })

  const triangle = horizontal
    ? `${width - 15} 3, ${width} ${height / 2}, ${width - 15} ${height - 3}`
    : `3 ${height - 15}, ${width / 2} ${height}, ${width - 3} ${height - 15}`

  return { line, getCircle, triangle }
}

const ProcessGraph: React.FC<Props> = ({
  steps = [],
  width = 0,
  height = 0,
  className,
}) => {
  const attrs = useMemo(
    () => getAttrs(width, height, steps.length),
    [width, height, steps.length]
  )

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
    >
      <line
        {...attrs.line}
        stroke="currentColor"
        strokeWidth={3}
        className="stroke-oxide"
      />

      {steps.map((_, idx) => (
        <circle
          key={idx}
          {...attrs.getCircle(idx)}
          r="12"
          className="fill-white stroke-oxide"
          strokeWidth={3}
        />
      ))}

      <polygon points={attrs.triangle} className="fill-oxide" />
    </svg>
  )
}

export default ProcessGraph
